.form-container {
    display: flex;
    flex-direction: row;
}
